import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("jl_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && localStorage.getItem("jl_token")) {
      // Silent: caller decides. Keep token if intentional (e.g. me() probe fails).
    }
    return Promise.reject(err);
  }
);

export default client;

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (typeof detail === "object" && detail.msg) return detail.msg;
  return String(detail);
}

// Convert a stored image reference (either a full https URL or an object-storage path)
// into a URL suitable for <img src>.
export function resolveImage(pathOrUrl) {
  if (!pathOrUrl) return "";
  if (pathOrUrl.startsWith("http://") || pathOrUrl.startsWith("https://")) {
    return pathOrUrl;
  }
  return `${API}/files/${pathOrUrl}`;
}

// For private files (payment proofs) — attaches ?auth= for <img> tags.
export function resolvePrivateImage(pathOrUrl) {
  if (!pathOrUrl) return "";
  if (pathOrUrl.startsWith("http://") || pathOrUrl.startsWith("https://")) {
    return pathOrUrl;
  }
  const token = localStorage.getItem("jl_token") || "";
  return `${API}/files/${pathOrUrl}?auth=${encodeURIComponent(token)}`;
}

export function formatRM(n) {
  if (n == null || isNaN(n)) return "RM 0.00";
  return `RM ${Number(n).toFixed(2)}`;
}
